import { render, staticRenderFns } from "./InstagramPostTable.vue?vue&type=template&id=4e247392&scoped=true"
import script from "./InstagramPostTable.vue?vue&type=script&lang=ts"
export * from "./InstagramPostTable.vue?vue&type=script&lang=ts"
import style0 from "./InstagramPostTable.vue?vue&type=style&index=0&id=4e247392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e247392",
  null
  
)

export default component.exports